class AjaxManager {
    constructor() {
        this.ajaxUrl = pc_ajax_object.ajax_url;
    }

    /**
     * Executes an AJAX request
     * @param {Object} params - Request parameters
     * @param {string} params.action - Action name
     * @param {string} params.nonce - Security nonce
     * @param {Object|FormData} params.data - Data to send
     * @param {boolean} params.showLoader - Whether to show the loader
     * @returns {Promise} Promise with request result
     */
    async makeRequest(params) {
        const { action, nonce, data = {}, showLoader = true } = params;

        if (showLoader) {
            $('.pc-preloader').css('display', 'flex').fadeIn(300);
        }

        let ajaxParams = {
            url: this.ajaxUrl,
            type: 'POST',
            data: data instanceof FormData ? data : { action, nonce, ...data }
        };

        // If data is passed as FormData
        if (data instanceof FormData) {
            data.append('action', action);
            data.append('nonce', nonce);
            ajaxParams = {
                ...ajaxParams,
                processData: false,
                contentType: false
            };
        }

        console.log(ajaxParams);

        try {
            const response = await $.ajax(ajaxParams);
            return response;
        } catch (error) {
            console.error('Ajax error:', error);
            throw error;
        } finally {
            if (showLoader) {
                $('.pc-preloader').fadeOut(300);
            }
        }
    }

    /**
     * Save quote
     * @param {Object} params - Request parameters
     * @returns {Promise}
     */
    async saveQuote(params) {

        const { configuratorId, quantity, quantity_variants, options, fileInput } = params;

        console.log(quantity_variants);
        
        const userData = {
            userId: params.userId,
            userEmail: params.userEmail,
            userName: params.userName,
            isAdmin: params.isAdmin
        }

        const formData = new FormData();
        formData.append('configurator_id', configuratorId);

        formData.append('quantity', quantity);
        formData.append('quantity_variants', quantity_variants);
        formData.append('options', JSON.stringify(options));
        formData.append('userData', JSON.stringify(userData));
        formData.append('current_url', window.location.href);
        
        if (fileInput && fileInput.files[0]) {
            formData.append('custom_file', fileInput.files[0]);
        }

        return this.makeRequest({
            action: 'pc_save_quote',
            nonce: pc_ajax_object.nonce_quote,
            data: formData
        });
    }

    async loadPopupContent(configuratorId, hash) {

        console.log(configuratorId, hash);

        return this.makeRequest({
            action: 'pc_load_popup',
            nonce: pc_ajax_object.nonce_popup,
            data: { configurator_id: configuratorId, hash: hash }
        });
    }
} 